import { useRouteLoaderData } from 'react-router-dom';
import type { IRootLoaderData } from '../types';

export function useRootLoaderData() {
  return useRouteLoaderData('root') as IRootLoaderData;
}
